import { ReactNode } from "react"
import { LocationProvider, globalHistory } from "@reach/router"
import { Favicon, GlobalStyles, AddMapScripts, ThemeProvider } from "@shared/primitive-components"
import { theme } from "../theme/theme"
import favicon from "../assets/favicon.ico"
import globalStyles from "../styles/globalStyle"
import GlobalFont from "../styles/GlobalFont"

interface Props {
  children: ReactNode
}

/**
 * Takes care of top-level ui:
 * - global style application
 * - favicon
 */
export const AppWrapper = ({ children }: Props) => (
  <LocationProvider history={globalHistory}>
    <ThemeProvider theme={theme}>
      <AddMapScripts />
      <GlobalFont />
      <GlobalStyles css={globalStyles}>
        <Favicon icon={favicon} />
        {children}
      </GlobalStyles>
    </ThemeProvider>
  </LocationProvider>
)
